import { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router';

import { useError } from '../contexts/useError';
import { DownloadDetailedPage } from '../pages/DownloadDetailedPage';
import { DownloadHomePage } from '../pages/DownloadHomePage';
import { ErrorPage } from '../pages/ErrorPage';

export const AppRoutes = () => {
  const { pathname } = useLocation();
  const { error, setError } = useError();

  // reset error code on page load or change
  useEffect(() => {
    setError({ statusCode: 200 });
  }, [pathname, setError]);

  // if there's an error from the error context (ie not 200 ok response), render the error page with the code. the errorpage component will pull the relevant data from the config. defaults to 500 response
  if (error?.statusCode && error.statusCode !== 200)
    return (
      <Routes>
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    );

  return (
    <Routes>
      <Route path="/" element={<DownloadHomePage />} />
      <Route path="/details/:artifactKey" element={<DownloadDetailedPage />} />
      <Route path="*" element={<ErrorPage statusCode={404} />} />
    </Routes>
  );
};
